import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export const LANGUAGES = [
  "English", "Hindi", "Hinglish", "Marathi", "Tamil", "Telugu", "Bengali", "Gujarati", "Kannada", "Punjabi", "Malayalam",
];

// Indian exams we support — used for "Which exam are you preparing for?"
// so the tutor can calibrate depth/format (NEET MCQ traps, UPSC perspective, board basics, etc.).
export const EXAMS = [
  { value: "", label: "Not sure yet" },
  { value: "JEE", label: "JEE (Main / Advanced)" },
  { value: "NEET", label: "NEET" },
  { value: "UPSC", label: "UPSC Civil Services" },
  { value: "CUET", label: "CUET" },
  { value: "MHT-CET", label: "MHT-CET (Maharashtra)" },
  { value: "KCET", label: "KCET (Karnataka)" },
  { value: "EAMCET", label: "EAMCET (AP / TS)" },
  { value: "WBJEE", label: "WBJEE (West Bengal)" },
  { value: "GUJCET", label: "GUJCET (Gujarat)" },
  { value: "KEAM", label: "KEAM (Kerala)" },
  { value: "MPSC", label: "MPSC (Maharashtra PSC)" },
  { value: "TNPSC", label: "TNPSC (Tamil Nadu PSC)" },
  { value: "OtherPSC", label: "Other State PSC" },
  { value: "ClassX", label: "Class 10 Board" },
  { value: "ClassXII", label: "Class 11 / 12 Board" },
  { value: "Graduation", label: "Graduation / UG" },
  { value: "Other", label: "Other" },
];
